import axiosInstance from './axiosInstance';

/*export const fetchCalendarEvents = async (start, end) => {
  if (!start || !end) return [];
  
  try {
    const response = await axiosInstance.get('/manifests/calendar', {
      params: { start, end }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching calendar events:', error);
    throw error;
  }
};*/

export const fetchCalendarEvents = async ({
  start,
  end,
  serProInt,
  tipoServicioId,
  tipoServicioCodigo,
  proyectoId,
  estados,
  limit,
  offset,
} = {}) => {
  if (!start || !end) {
    return { data: [], pagination: { count: 0 } };
  }

  const params = { start, end };

  if (typeof serProInt === 'boolean') {
    params.serProInt = serProInt;
  }

  if (tipoServicioId !== undefined && tipoServicioId !== null) {
    params.tipoServicioId = tipoServicioId;
  }

  if (tipoServicioCodigo) {
    params.tipoServicioCodigo = tipoServicioCodigo;
  }

  if (proyectoId !== undefined && proyectoId !== null) {
    params.proyectoId = proyectoId;
  }

  if (Array.isArray(estados) && estados.length > 0) {
    params.estados = estados.join(',');
  }

  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;

  const response = await axiosInstance.get('/manifests/calendar', { params });
  return response.data;
};